import React from "react";
import { Button } from "react-bootstrap";
import {
  FaEdit,
  FaFileImport,
  FaMinus,
  FaMinusCircle,
  FaPlus,
  FaPlusCircle,
  FaTrash,
} from "react-icons/fa";

const CardOwnerControls = ({
  approvedGallery,
  hasTokens,
  isInGallery,
  onAddTokens,
  onDelete,
  onEdit,
  onGalleryToggle,
  onImport,
  onRemoveTokens,
}) => (
  <div className="mainControls mt-3">
    <div className="cardControl mb-3 d-flex justify-content-between gap-3">
      <Button
        variant="danger"
        className="flex-fill d-flex flex-column align-items-center justify-content-center w-25"
        style={{ flexBasis: 0 }}
        onClick={onDelete}
      >
        <FaTrash
          className="mb-1"
          style={{ fontSize: "1.2rem", marginTop: "0.225em" }}
        />
        <span>Delete</span>
      </Button>

      <Button
        variant="primary"
        className="flex-fill d-flex flex-column align-items-center justify-content-center w-25"
        style={{ flexBasis: 0 }}
        onClick={onEdit}
      >
        <FaEdit
          className="mb-1"
          style={{ fontSize: "1.2rem", marginTop: "0.225em" }}
        />
        <span>Edit</span>
      </Button>

      <Button
        variant="primary"
        className="flex-fill d-flex flex-column align-items-center justify-content-center w-25"
        style={{ flexBasis: 0 }}
        onClick={onImport}
      >
        <FaFileImport
          className="mb-1"
          style={{ fontSize: "1.2rem", marginTop: "0.225em" }}
        />
        <span>Import</span>
      </Button>

      {Number(approvedGallery) !== 5 && (
        <Button
          variant={isInGallery ? "danger" : "success"}
          className="flex-fill d-flex flex-column align-items-center justify-content-center w-25"
          style={{ flexBasis: 0 }}
          onClick={onGalleryToggle}
        >
          {isInGallery ? (
            <FaMinusCircle
              className="mb-1"
              style={{ fontSize: "1.2rem", marginTop: "0.225em" }}
            />
          ) : (
            <FaPlusCircle
              className="mb-1"
              style={{ fontSize: "1.2rem", marginTop: "0.225em" }}
            />
          )}
          <span>{isInGallery ? "Unsubmit" : "Submit"}</span>
        </Button>
      )}
    </div>

    <div className="tokensControl mb-3 d-flex justify-content-between">
      <Button
        variant="success"
        className={hasTokens ? "flex-fill me-2" : "flex-fill"}
        onClick={onAddTokens}
      >
        <FaPlus className="me-2" />
        Add Tokens
      </Button>

      {hasTokens && (
        <Button variant="danger" className="flex-fill" onClick={onRemoveTokens}>
          <FaMinus className="me-2" />
          Remove Tokens
        </Button>
      )}
    </div>
  </div>
);

export default CardOwnerControls;
